import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const SupportSection = () => {
  const supportOptions = [
    {
      icon: "Mail",
      title: "Email Support",
      value: "support@studyexpo.com",
      action: "mailto:support@studyexpo.com"
    },
    {
      icon: "Phone",
      title: "Phone Support",
      value: "+1 (555) 123-4567",
      action: "tel:+15551234567"
    },
    {
      icon: "MessageCircle",
      title: "Live Chat",
      value: "Available 24/7",
      action: "#"
    }
  ];

  return (
    <div className="bg-muted/50 rounded-lg p-6 md:p-8 border border-border">
      <div className="flex items-center gap-2 mb-4">
        <Icon name="Headphones" size={24} color="var(--color-primary)" />
        <h3 className="text-lg md:text-xl font-heading font-semibold text-foreground">
          Need Help?
        </h3>
      </div>
      <p className="text-sm md:text-base text-muted-foreground mb-6">
        Our support team is available to assist you with login issues, account setup, or any technical questions.
      </p>
      <div className="space-y-3">
        {supportOptions?.map((option, index) => (
          <a
            key={index}
            href={option?.action}
            className="flex items-center gap-3 p-3 bg-card rounded-lg border border-border hover:border-primary/30 transition-smooth"
          >
            <div className="flex-shrink-0 w-10 h-10 bg-primary/10 rounded-lg flex items-center justify-center">
              <Icon name={option?.icon} size={20} color="var(--color-primary)" />
            </div>
            <div className="flex-1 min-w-0">
              <div className="text-sm font-medium text-foreground">
                {option?.title}
              </div>
              <div className="text-xs text-muted-foreground">
                {option?.value}
              </div>
            </div>
            <Icon name="ExternalLink" size={16} color="var(--color-muted-foreground)" />
          </a>
        ))}
      </div>
      <div className="mt-6 pt-6 border-t border-border">
        <Button
          variant="outline"
          fullWidth
          iconName="FileText"
          iconPosition="left"
        >
          View Documentation
        </Button>
      </div>
    </div>
  );
};

export default SupportSection;